/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../src/app/search-panel/components/query-selector.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../src/app/search-panel/services/search-api.service';
import * as import10 from '../../../../../src/app/search-panel/services/search-config.service';
import * as import11 from './query-selector.component.css.shim.ngstyle';
import * as import12 from 'ng2-translate/src/translate.pipe';
import * as import13 from '@angular/core/src/linker/view_container';
import * as import14 from 'ng2-translate/src/translate.service';
import * as import15 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/select_control_value_accessor.ngfactory';
import * as import16 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/select_multiple_control_value_accessor.ngfactory';
import * as import17 from '@angular/core/src/linker/element_ref';
import * as import18 from '@angular/forms/src/directives/select_control_value_accessor';
import * as import19 from '@angular/forms/src/directives/select_multiple_control_value_accessor';
import * as import20 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import21 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import22 from '../../../../../$$_gendir/node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import23 from '@angular/core/src/linker/template_ref';
import * as import24 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import25 from '@angular/common/src/directives/ng_for';
import * as import26 from '@angular/forms/src/directives/control_value_accessor';
import * as import27 from '@angular/forms/src/directives/ng_model';
import * as import28 from '@angular/forms/src/directives/ng_control';
import * as import29 from '@angular/forms/src/directives/ng_control_status';
import * as import30 from '../../../../../src/app/shared/components/status.component';
import * as import31 from '../../shared/components/status.component.ngfactory';
import * as import32 from '../../../../../$$_gendir/node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import33 from '@angular/common/src/directives/ng_if';
export class Wrapper_QuerySelectorComponent {
  /*private*/ _eventHandler:Function;
  context:import0.QuerySelectorComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  subscription0:any;
  constructor(p0:any,p1:any) {
    this._changed = false;
    this.context = new import0.QuerySelectorComponent(p0,p1);
    this._expr_0 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
  }
  check_selection(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.selection = currValue;
      this._expr_0 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.selectionChange.subscribe(_eventHandler.bind(view,'selectionChange'))); }
  }
}
var renderType_QuerySelectorComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_QuerySelectorComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.QuerySelectorComponent>;
  _QuerySelectorComponent_0_3:Wrapper_QuerySelectorComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_QuerySelectorComponent_Host0,renderType_QuerySelectorComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'obpa-query-selector',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_QuerySelectorComponent0(this.viewUtils,this,0,this._el_0);
    this._QuerySelectorComponent_0_3 = new Wrapper_QuerySelectorComponent(this.injectorGet(import9.SearchApiService,this.parentIndex),this.injectorGet(import10.SearchConfigService,this.parentIndex));
    this.compView_0.create(this._QuerySelectorComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._QuerySelectorComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.QuerySelectorComponent) && (0 === requestNodeIndex))) { return this._QuerySelectorComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._QuerySelectorComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._QuerySelectorComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const QuerySelectorComponentNgFactory:import8.ComponentFactory<import0.QuerySelectorComponent> = new import8.ComponentFactory<import0.QuerySelectorComponent>('obpa-query-selector',View_QuerySelectorComponent_Host0,import0.QuerySelectorComponent);
const styles_QuerySelectorComponent:any[] = [import11.styles];
class View_QuerySelectorComponent1 extends import2.AppView<any> {
  _text_0:any;
  _el_1:any;
  _text_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  /*private*/ _expr_7:any;
  _pipe_translate_0:import12.TranslatePipe;
  /*private*/ _expr_9:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import13.ViewContainer) {
    super(View_QuerySelectorComponent1,renderType_QuerySelectorComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_7 = import1.UNINITIALIZED;
    this._expr_9 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._text_0 = this.renderer.createText((null as any),'\n            ',(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,(null as any),'label',new import3.InlineArray2(2,'id','obpa_query_label'),(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'',(null as any));
    this._text_3 = this.renderer.createText((null as any),'\n            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,(null as any),'p',new import3.InlineArray8(6,'aria-labelledby','obpa_query_label','class','form-control-static','tabindex','0'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._pipe_translate_0 = new import12.TranslatePipe(this.parentView.injectorGet(import14.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._text_6,((<any>this.renderer).directRenderer? (null as any): [
      this._text_0,
      this._el_1,
      this._text_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_7:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('SEARCH TYPE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_7,currVal_7))) {
      this.renderer.setText(this._text_2,currVal_7);
      this._expr_7 = currVal_7;
    }
    const currVal_9:any = import3.inlineInterpolate(1,'',((this.parentView.context.selection == null)? (null as any): this.parentView.context.selection.name),'');
    if (import3.checkBinding(throwOnChange,this._expr_9,currVal_9)) {
      this.renderer.setText(this._text_5,currVal_9);
      this._expr_9 = currVal_9;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._text_0,ctx);
    cb(this._el_1,ctx);
    cb(this._text_3,ctx);
    cb(this._el_4,ctx);
    cb(this._text_6,ctx);
  }
}
class View_QuerySelectorComponent3 extends import2.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import15.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import16.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import13.ViewContainer) {
    super(View_QuerySelectorComponent3,renderType_QuerySelectorComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._NgSelectOption_0_3 = new import15.Wrapper_NgSelectOption(new import17.ElementRef(this._el_0),this.renderer,(<View_QuerySelectorComponent2>this.parentView)._SelectControlValueAccessor_4_3.context);
    this._NgSelectMultipleOption_0_4 = new import16.Wrapper_NgSelectMultipleOption(new import17.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import19.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.context.$implicit;
    this._NgSelectOption_0_3.check_ngValue(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = this.context.$implicit;
    this._NgSelectMultipleOption_0_4.check_ngValue(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_4:any = import3.inlineInterpolate(1,'',this.context.$implicit.name,'');
    if (import3.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_QuerySelectorComponent2 extends import2.AppView<any> {
  _text_0:any;
  _el_1:any;
  _text_2:any;
  _text_3:any;
  _el_4:any;
  _SelectControlValueAccessor_4_3:import15.Wrapper_SelectControlValueAccessor;
  _NG_VALUE_ACCESSOR_4_4:any[];
  _NgModel_4_5:import20.Wrapper_NgModel;
  _NgControl_4_6:any;
  _NgControlStatus_4_7:import21.Wrapper_NgControlStatus;
  _text_5:any;
  _anchor_6:any;
  /*private*/ _vc_6:import13.ViewContainer;
  _TemplateRef_6_5:any;
  _NgFor_6_6:import22.Wrapper_NgFor;
  _text_7:any;
  _text_8:any;
  /*private*/ _expr_17:any;
  _pipe_translate_0:import12.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import13.ViewContainer) {
    super(View_QuerySelectorComponent2,renderType_QuerySelectorComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_17 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._text_0 = this.renderer.createText((null as any),'\n            ',(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,(null as any),'label',new import3.InlineArray2(2,'for','obpa_query'),(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'',(null as any));
    this._text_3 = this.renderer.createText((null as any),'\n            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,(null as any),'select',new import3.InlineArray4(4,'class','form-control','id','obpa_query'),(null as any));
    this._SelectControlValueAccessor_4_3 = new import15.Wrapper_SelectControlValueAccessor(this.renderer,new import17.ElementRef(this._el_4));
    this._NG_VALUE_ACCESSOR_4_4 = [this._SelectControlValueAccessor_4_3.context];
    this._NgModel_4_5 = new import20.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_4_4);
    this._NgControl_4_6 = this._NgModel_4_5.context;
    this._NgControlStatus_4_7 = new import21.Wrapper_NgControlStatus(this._NgControl_4_6);
    this._text_5 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._anchor_6 = this.renderer.createTemplateAnchor(this._el_4,(null as any));
    this._vc_6 = new import13.ViewContainer(6,4,this,this._anchor_6);
    this._TemplateRef_6_5 = new import23.TemplateRef_(this,6,this._anchor_6);
    this._NgFor_6_6 = new import22.Wrapper_NgFor(this._vc_6.vcRef,this._TemplateRef_6_5,this.parentView.parentView.injectorGet(import24.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_7 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._text_8 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._pipe_translate_0 = new import12.TranslatePipe(this.parentView.injectorGet(import14.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray8(6,'ngModelChange',(null as any),'change',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_4));
    this._NgModel_4_5.subscribe(this,this.eventHandler(this.handleEvent_4),true);
    this.init(this._text_8,((<any>this.renderer).directRenderer? (null as any): [
      this._text_0,
      this._el_1,
      this._text_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._anchor_6,
      this._text_7,
      this._text_8
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.TemplateRef) && (6 === requestNodeIndex))) { return this._TemplateRef_6_5; }
    if (((token === import25.NgFor) && (6 === requestNodeIndex))) { return this._NgFor_6_6.context; }
    if (((token === import18.SelectControlValueAccessor) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 7)))) { return this._SelectControlValueAccessor_4_3.context; }
    if (((token === import26.NG_VALUE_ACCESSOR) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 7)))) { return this._NG_VALUE_ACCESSOR_4_4; }
    if (((token === import27.NgModel) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 7)))) { return this._NgModel_4_5.context; }
    if (((token === import28.NgControl) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 7)))) { return this._NgControl_4_6; }
    if (((token === import29.NgControlStatus) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 7)))) { return this._NgControlStatus_4_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    this._SelectControlValueAccessor_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_4_1_0:any = this.parentView.context.selection;
    this._NgModel_4_5.check_model(currVal_4_1_0,throwOnChange,false);
    this._NgModel_4_5.ngDoCheck(this,this._el_4,throwOnChange);
    this._NgControlStatus_4_7.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_6_0_0:any = this.parentView.context.queries;
    this._NgFor_6_6.check_ngForOf(currVal_6_0_0,throwOnChange,false);
    this._NgFor_6_6.ngDoCheck(this,this._anchor_6,throwOnChange);
    this._vc_6.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_17:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('SEARCH TYPE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_17,currVal_17))) {
      this.renderer.setText(this._text_2,currVal_17);
      this._expr_17 = currVal_17;
    }
    this._NgControlStatus_4_7.checkHost(this,this,this._el_4,throwOnChange);
  }
  destroyInternal():void {
    this._vc_6.destroyNestedViews();
    this._NgModel_4_5.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._text_0,ctx);
    cb(this._el_1,ctx);
    cb(this._text_3,ctx);
    cb(this._el_4,ctx);
    cb(this._text_8,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 6)) { return new View_QuerySelectorComponent3(this.viewUtils,this,6,this._anchor_6,this._vc_6); }
    return (null as any);
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._SelectControlValueAccessor_4_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'ngModelChange')) {
      const pd_sub_0:any = ((<any>this.parentView.context.onSelectionChange($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_QuerySelectorComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.Emulated,styles_QuerySelectorComponent,{});
export class View_QuerySelectorComponent0 extends import2.AppView<import0.QuerySelectorComponent> {
  _el_0:any;
  compView_0:import2.AppView<import30.StatusComponent>;
  _StatusComponent_0_3:import31.Wrapper_StatusComponent;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _vc_4:import13.ViewContainer;
  _TemplateRef_4_5:any;
  _NgIf_4_6:import32.Wrapper_NgIf;
  _text_5:any;
  _anchor_6:any;
  /*private*/ _vc_6:import13.ViewContainer;
  _TemplateRef_6_5:any;
  _NgIf_6_6:import32.Wrapper_NgIf;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _pipe_translate_0:import12.TranslatePipe;
  /*private*/ _expr_22:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_QuerySelectorComponent0,renderType_QuerySelectorComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_22 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'obpa-status',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_0 = new import31.View_StatusComponent0(this.viewUtils,this,0,this._el_0);
    this._StatusComponent_0_3 = new import31.Wrapper_StatusComponent();
    this._text_1 = this.renderer.createText((null as any),'\n\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','form-group'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n\n        ',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._vc_4 = new import13.ViewContainer(4,2,this,this._anchor_4);
    this._TemplateRef_4_5 = new import23.TemplateRef_(this,4,this._anchor_4);
    this._NgIf_4_6 = new import32.Wrapper_NgIf(this._vc_4.vcRef,this._TemplateRef_4_5);
    this._text_5 = this.renderer.createText(this._el_2,'\n\n        ',(null as any));
    this._anchor_6 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._vc_6 = new import13.ViewContainer(6,2,this,this._anchor_6);
    this._TemplateRef_6_5 = new import23.TemplateRef_(this,6,this._anchor_6);
    this._NgIf_6_6 = new import32.Wrapper_NgIf(this._vc_6.vcRef,this._TemplateRef_6_5);
    this._text_7 = this.renderer.createText(this._el_2,'\n\n    ',(null as any));
    this._text_8 = this.renderer.createText((null as any),'\n\n    ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray4(4,'class','help-block','tabindex','0'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'',(null as any));
    this._text_11 = this.renderer.createText((null as any),'\n    \n',(null as any));
    this.compView_0.create(this._StatusComponent_0_3.context);
    this._text_12 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'retry',(null as any)),this.eventHandler(this.handleEvent_0));
    this._StatusComponent_0_3.subscribe(this,this.eventHandler(this.handleEvent_0),true);
    this._pipe_translate_0 = new import12.TranslatePipe(this.parentView.injectorGet(import14.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._anchor_4,
      this._text_5,
      this._anchor_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._text_12
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import33.NgIf) && (4 === requestNodeIndex))) { return this._NgIf_4_6.context; }
    if (((token === import23.TemplateRef) && (6 === requestNodeIndex))) { return this._TemplateRef_6_5; }
    if (((token === import33.NgIf) && (6 === requestNodeIndex))) { return this._NgIf_6_6.context; }
    if (((token === import30.StatusComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 11)))) { return this._StatusComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_0_0_0:any = this.context.status;
    this._StatusComponent_0_3.check_status(currVal_0_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_0_0_1:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('ERROR: QUERIES')),'');
    this._StatusComponent_0_3.check_error(currVal_0_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    this._StatusComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_4_0_0:any = this.context.showSingleQuery;
    this._NgIf_4_6.check_ngIf(currVal_4_0_0,throwOnChange,false);
    this._NgIf_4_6.ngDoCheck(this,this._anchor_4,throwOnChange);
    const currVal_6_0_0:boolean = !this.context.showSingleQuery;
    this._NgIf_6_6.check_ngIf(currVal_6_0_0,throwOnChange,false);
    this._NgIf_6_6.ngDoCheck(this,this._anchor_6,throwOnChange);
    this._vc_4.detectChangesInNestedViews(throwOnChange);
    this._vc_6.detectChangesInNestedViews(throwOnChange);
    const currVal_22:any = import3.inlineInterpolate(1,'',((this.context.selection == null)? (null as any): this.context.selection.instructions),'');
    if (import3.checkBinding(throwOnChange,this._expr_22,currVal_22)) {
      this.renderer.setText(this._text_10,currVal_22);
      this._expr_22 = currVal_22;
    }
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this._vc_4.destroyNestedViews();
    this._vc_6.destroyNestedViews();
    this.compView_0.destroy();
    this._StatusComponent_0_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitProjectableNodesInternal(nodeIndex:number,ngContentIndex:number,cb:any,ctx:any):void {
    if (((nodeIndex == 0) && (ngContentIndex == 0))) {
      cb(this._text_1,ctx);
      cb(this._el_2,ctx);
      cb(this._text_8,ctx);
      cb(this._el_9,ctx);
      cb(this._text_11,ctx);
    }
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 4)) { return new View_QuerySelectorComponent1(this.viewUtils,this,4,this._anchor_4,this._vc_4); }
    if ((nodeIndex == 6)) { return new View_QuerySelectorComponent2(this.viewUtils,this,6,this._anchor_6,this._vc_6); }
    return (null as any);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'retry')) {
      const pd_sub_0:any = ((<any>this.context.onRetry()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./$$_gendir/src/app/search-panel/components/query-selector.component.ngfactory.ts